import { govPoolABI } from '../abi';

export const bscStakePools = [
  {
    id: 'bifi-bnb',
    name: 'BIFI',
    logo: 'single-assets/BIFI.png',
    token: 'BIFI',
    tokenDecimals: 18,
    tokenAddress: '0xCa3F508B8e4Dd382eE878A314789373D80A5190A',
    tokenOracle: 'tokens',
    tokenOracleId: 'BIFI',
    earnedToken: 'BNB',
    earnedTokenDecimals: 18,
    earnedTokenAddress: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    earnContractAddress: '0x453D4Ba9a2D594314DF88564248497F7D74d6b2C',
    earnContractAbi: govPoolABI,
    earnedOracle: 'tokens',
    earnedOracleId: 'WBNB',
    partnership: false,
    status: 'active',
    fixedStatus: true,
    partners: [
      {
        logo: 'stake/beefy/beefyfinance.png',
        logoNight: 'stake/beefy/beefyfinance_night.png',
        background: 'stake/beefy/background.png',
        text: "You probably already knew that Beefy is the most trusted Yield optimizer for the Binance Smart Chain. But did you know that Beefy has its own token? $BIFI has a maximum supply of 80000 tokens and there is no way to mint more. Everyone who holds our own $BIFI token can not only do cool stuff like create and vote on proposals, they also get a share of all harvests done, every hour, every day on all our +120 vaults. That's a lot of BNB that goes straight to our $BIFI holders. All you have to do is stake your $BIFI in this vault, it’s that simple, come back and harvest your BNB whenever you need it! (You can still vote on proposals even though you have staked your $BIFI here).",
        website: 'https://app.beefy.finance',
        social: {
          telegram: 'http://t.me/beefyfinance',
          twitter: 'https://twitter.com/beefyfinance',
        },
      },
    ],
  },
  {
    id: 'moo_bifi-honeyfarm',
    name: 'HoneyFarm',
    logo: 'single-assets/BIFI.png',
    token: 'mooBIFI',
    tokenDecimals: 18,
    tokenAddress: '0xf7069e41C57EcC5F122093811d8c75bdB5f7c14e',
    tokenOracle: 'tokens',
    tokenOracleId: 'BIFI',
    earnedToken: 'HONEY',
    earnedTokenDecimals: 18,
    earnedTokenAddress: '0xFa363022816aBf82f18a9C2809dCd2BB393F6AC5',
    earnContractAddress: '0x08B5d70e9e5A5117594889Baf078f6C5a3FfeC36',
    earnContractAbi: govPoolABI,
    earnedOracle: 'tokens',
    earnedOracleId: 'HONEY',
    partnership: true,
    status: 'active',
    isMooStaked: true,
    periodFinish: 1628854565,
    partners: [
      {
        logo: 'stake/honey/logo.png',
        background: 'stake/honey/bg.png',
        text: "HoneyFarm Finance is a layered delegated yield farming project with deflationary tokenomics of a maximum supply of 24,650 HONEY tokens. There will be multiple layered projects and each layer will also has pools with previous layers' native tokens. The whole project will be finished after the final emission of a certain layered project, which will be announced in advance.",
        website: 'https://honeyfarm.finance/',
        social: {
          telegram: 'https://t.me/HoneyFarmChat',
          twitter: 'https://twitter.com/HoneyFarmFi',
        },
      },
    ],
  },
  {
    id: 'moo_banana-pera',
    name: 'Pera',
    logo: 'degens/BANANA.svg',
    token: 'mooApeBANANA',
    tokenDecimals: 18,
    tokenAddress: '0xD307e7CC6a302046b7D91D83aa4B8324cFB7a786',
    tokenOracle: 'tokens',
    tokenOracleId: 'BANANA',
    earnedToken: 'PERA',
    earnedTokenDecimals: 18,
    earnedTokenAddress: '0xb9D8592E16A9c1a3AE6021CDDb324EaC1Cbc70d6',
    earnContractAddress: '0x38247fCE28480A7BEF2CB7aD134ce091Bd2E1a82',
    earnContractAbi: govPoolABI,
    earnedOracle: 'tokens',
    earnedOracleId: 'PERA',
    partnership: true,
    status: 'active',
    isMooStaked: true,
    periodFinish: 1628453723,
    partners: [
      {
        logo: 'stake/pera/logo.png',
        background: 'stake/pera/bg.png',
        text: "Pera Finance is a decentralized trading competition platform with multi-layered yield farming opportunities. Traders, liquidity providers and holders yield farm together through the DeFi's first decentralized trading competition. Every on-chain PERA transaction (transfer, trade, or liquidity addition/ removal) generates a 2 % transaction fee.",
        website: 'https://pera.finance/',
        social: {
          telegram: 'https://t.me/perafinance',
          twitter: 'https://twitter.com/perafinance',
        },
      },
    ],
  },
];
